import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UsersModel } from 'common/models/page-models/users/user-data-model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { UsersFormWidgetService } from 'common/widget/users/users-form-widget.service';

@Injectable({
    providedIn: 'root'
})
export class UsersFormResolver extends FormResolverService<UsersModel> {
    constructor(
        protected fs: UsersFormWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }
}
